// A column in auto width is sized by its content: it must never collapse, as
// a container query would stop its content from widening the column.
export function isFixedWidthColumn(column: {
  visual?: { width?: number | string | null }
}): boolean {
  const width = column.visual?.width
  return !!width && width !== 'auto'
}
